import IaqfazIntegrationClient from './iaqfazIntegration.client'

export default class IaqfazIntegrationService {
  constructor() {
    this.client = new IaqfazIntegrationClient()
  }

  async getWorkflows(params = {}) {
    try {
      return await this.client.getWorkflows(params)
    } catch (error) {
      console.error('Erro ao buscar workflows:', error)
      throw error
    }
  }

  async createWorkflow(data) {
    try {
      return await this.client.createWorkflow(data)
    } catch (error) {
      console.error('Erro ao criar workflow:', error)
      throw error
    }
  }

  async updateWorkflow(id, data) {
    try {
      return await this.client.updateWorkflow(id, data)
    } catch (error) {
      console.error('Erro ao atualizar workflow:', error)
      throw error
    }
  }

  async deleteWorkflow(id) {
    try {
      return await this.client.deleteWorkflow(id)
    } catch (error) {
      console.error('Erro ao deletar workflow:', error)
      throw error
    }
  }
}
